import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useUserData, Attendance } from '../../hooks/useUserData';
import { AttendanceCard, ModalFilters, OrderBtn } from '../../components';
import useAuth from '../../hooks/useAuth';
import { convertStatusToPortuguese } from '../../utils';
import { FilterKeys } from '../../utils/types';
import { convertingStatusTable } from '../../utils/translation';
import { filterUserData } from '../../utils/attendanceFilters';

const ListAttendance = () => {
  const [modalIsOpened, setModalIsOpened] = useState<boolean>(false);
  const { apiDomain } = useFlags();
  const { isLogged } = useAuth();
  const { userData, sortData } = useUserData(apiDomain);
  const [filterValues, setFilterValues] = useState<FilterKeys>({});
  const [modalFilterValues, setModalFilterValues] = useState<FilterKeys>({});
  const { t } = useTranslation('list_attendance');
  const userDataFiltered = filterUserData(userData, filterValues);

  if (isLogged) {
    <div />;
  }

  const handleClearFilters = () => {
    setFilterValues({});
    setModalFilterValues({});
  };

  const openFilterModal = () => setModalIsOpened(true);

  const handleClose = () => setModalIsOpened((current) => !current);

  return (
    <div className="vbz-list-attendance-container" data-testid="vbz-list-attendance">
      <h3 className="vbz-list-attendance-container__title">{t('title')}</h3>
      <div className="vbz-list-attendance-container__filter">
        <div className="vbz-list-attendance-container__buttons">
          <button className="btn btn-pills" type="button" onClick={openFilterModal} data-testid="vbz-list-btn-filter">
            <i className="material-icons material-icons-round" role="img">
              filter_list
            </i>
            <span>{t('filter')}</span>
          </button>
          <OrderBtn handleSelectOrder={sortData} />
        </div>
        {Object.keys(filterValues).length > 0 && (
          <div className="vbz-list-attendance-container__clear-filters">
            <button className="btn btn-pills btn-filter" type="button" onClick={handleClearFilters}>
              Limpar filtros
            </button>
          </div>
        )}
      </div>
      <div className="vbz-list-attendance-container__labels">
        <span className="vbz-list-attendance-container__labels__label--date">{t('date')}</span>
        <span className="vbz-list-attendance-container__labels__label--number">{t('attendanceNumber')}</span>
        <span className="vbz-list-attendance-container__labels__label--subject">{t('subject')}</span>
        <span className="vbz-list-attendance-container__labels__label--status">{t('status')}</span>
      </div>
      <div className="vbz-list-attendance-container__cards">
        {userDataFiltered.length > 0 &&
          userDataFiltered.map((item: Attendance) => (
            <AttendanceCard
              createdAt={item.created_at}
              subject={item.subject}
              number={item.id}
              status={convertStatusToPortuguese(convertingStatusTable, item.status)}
              isOpened={false}
              key={item.id}
            />
          ))}
      </div>
      <ModalFilters
        isOpen={modalIsOpened}
        toggle={handleClose}
        setFilterValues={setFilterValues}
        modalFilterValues={modalFilterValues}
        setModalFilterValues={setModalFilterValues}
      />
    </div>
  );
};

export default ListAttendance;
